import React from 'react'
import Header from '../components/Header'
import Report from '../components/Report'
import InitialMessage from '../components/InitialMessage'
import UpperImages from '../components/UpperImages'
import News from '../components/News'
import DownImages from '../components/DownImages'
import Footer from '../components/Footer'
import { useNavigate } from 'react-router-dom'
import UpperHeader from '../components/UpperHeader'


export default function Layout() {
    const navigate = useNavigate();

    const showMessage = () => {
        navigate("admin")
    };

    const keydownHandler = (e) => {
        if (e.key === 'i' && e.ctrlKey) showMessage()
    };

    React.useEffect(() => {
        document.addEventListener('keydown', keydownHandler);
        return () => {
            document.removeEventListener('keydown', keydownHandler);
        }
    }, []);

    return (
        <div>
            <img src="linea-de-color.jpg" alt='Linea Color' className='img-fluidLine reverse' style={{ marginBottom: "22px" }} />
            <UpperHeader child={false} />
            <Header />
            <Report />
            <InitialMessage />
            <UpperImages />
            <News />
            <DownImages />
            <Footer showmap={true} />
        </div>
    )
}
